'use client'

import { useLocale } from 'next-intl'

import { resolveDateLocale } from './dateLocale'

/**
 * Hook CLIENT que resolve o BCP-47 de DATA a partir do locale ativo do app (next-intl).
 * SEM gate: datas de conteúdo editorial sempre seguem o leitor (≠ números cripto, que ficam
 * fixos em pt-BR — ver `useNumberLocale.ts`).
 *
 * Em SERVER usar `resolveDateLocale(await getRequestLocale())` ou `formatEditorialDate(date, locale)`.
 */
export function useDateLocale(): string {
  return resolveDateLocale(useLocale())
}
